document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.hotspot-hero .hotspot__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var hotspot = btn.closest('.hotspot');
      var isOpen = hotspot.classList.contains('is-open');

      // zatvori sve hotspotove
      document.querySelectorAll('.hotspot-hero .hotspot.is-open').forEach(function (item) {
        item.classList.remove('is-open');
        var b = item.querySelector('.hotspot__btn');
        if (b) b.setAttribute('aria-expanded', 'false');
      });

      // ako prethodno nije bio otvoren → otvori ga
      if (!isOpen) {
        hotspot.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
});
